module.exports = __webpack_public_path__ + "img/2.e101c717.png";